import COUNTRIES from "libs/Countries";

export const COUNTRY_OPTIONS = COUNTRIES.map((item: { name: string; alpha2code: string }) => ({
  label: item.name,
  value: item.alpha2code,
}));
